import { DocumentType } from '~/types/document';
import { RelatedDocumentType } from '~/types/document-builder';

export const documentTypeToRelatedDocument = (document: DocumentType) => {
  switch (document) {
    case DocumentType.DeliveryNote:
      return RelatedDocumentType.Ddt;
    case DocumentType.Invoice:
      return RelatedDocumentType.FatturaCollegata;
    case DocumentType.CreditNote:
      return RelatedDocumentType.FatturaCollegata;
    case DocumentType.SelfInvoice:
      return RelatedDocumentType.FatturaCollegata;
    case DocumentType.Parcel:
      return RelatedDocumentType.FatturaCollegata;
    case DocumentType.Bill:
      return RelatedDocumentType.FatturaCollegata;
    case DocumentType.DebitNote:
      return RelatedDocumentType.FatturaCollegata;
    case DocumentType.Quote:
      return RelatedDocumentType.OrdineAcquisto;
    default:
      throw new Error('Unhandled document type');
  }
};
